import React, { useEffect, useState } from "react";
import Aos from "aos";
import axios from "axios";

const Announcements = () => {
  // Hooks
  const [hamburgerMenuOpened, setHamburgerMenuOpened] = useState(false);
  const [topContent, setTopContent] = useState();
  const [bottomContent, setBottomContent] = useState();

  useEffect(() => {
    Aos.init();
  }, []);

  useEffect(() => {
    axios
      .get(
        "https://musicpromotiontoday.com/altlanteans/fetch_announcements_content_core"
      )
      .then(function (response) {
        setTopContent(response.data.top_content);
        setBottomContent(response.data.bottom_content);
      });
  }, []);

  return (
    <React.Fragment>
      <main className="announcements-page">
        <nav data-aos="fade-down">
          <div className="container">
            <div className="nav-left">
              <a href="/" className="logo">
                <img src="/assets/images/brand/logo.png" alt="" />
              </a>
            </div>
            <div
              className={hamburgerMenuOpened ? "nav-right active" : "nav-right"}
            >
              <button
                className="hamburger-menu-close-trigger"
                onClick={() => {
                  setHamburgerMenuOpened(!hamburgerMenuOpened);
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.7909 10L19.4767 4.3142C20.1744 3.61648 20.1744 2.48523 19.4767 1.78693L18.2131 0.523295C17.5153 -0.174432 16.3841 -0.174432 15.6858 0.523295L10 6.20909L4.3142 0.523295C3.61648 -0.174432 2.48523 -0.174432 1.78693 0.523295L0.523295 1.78693C-0.174432 2.48466 -0.174432 3.61591 0.523295 4.3142L6.20909 10L0.523295 15.6858C-0.174432 16.3835 -0.174432 17.5148 0.523295 18.2131L1.78693 19.4767C2.48466 20.1744 3.61648 20.1744 4.3142 19.4767L10 13.7909L15.6858 19.4767C16.3835 20.1744 17.5153 20.1744 18.2131 19.4767L19.4767 18.2131C20.1744 17.5153 20.1744 16.3841 19.4767 15.6858L13.7909 10Z"
                    fill="white"
                  />
                </svg>
              </button>

              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/anouncements">Announcments</a>
                </li>
                <li>
                  <a href="/">About Us</a>
                </li>
                <li>
                  <a href="/">RoadMap</a>
                </li>
                <li>
                  <a href="/">FAQs</a>
                </li>
              </ul>

              <button className="connect-wallet-btn">Connect Wallet</button>
            </div>

            <button
              className="hamburger-menu-open-trigger"
              onClick={() => {
                setHamburgerMenuOpened(!hamburgerMenuOpened);
              }}
            >
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.714286 3.26531H19.2857C19.6802 3.26531 20 2.94045 20 2.53968V0.725624C20 0.324853 19.6802 0 19.2857 0H0.714286C0.319777 0 0 0.324853 0 0.725624V2.53968C0 2.94045 0.319777 3.26531 0.714286 3.26531ZM0.714286 10.5215H19.2857C19.6802 10.5215 20 10.1967 20 9.79592V7.98186C20 7.58109 19.6802 7.25624 19.2857 7.25624H0.714286C0.319777 7.25624 0 7.58109 0 7.98186V9.79592C0 10.1967 0.319777 10.5215 0.714286 10.5215ZM0.714286 17.7778H19.2857C19.6802 17.7778 20 17.4529 20 17.0522V15.2381C20 14.8373 19.6802 14.5125 19.2857 14.5125H0.714286C0.319777 14.5125 0 14.8373 0 15.2381V17.0522C0 17.4529 0.319777 17.7778 0.714286 17.7778Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </nav>

        <section className="top-content">
          <div className="container">
            <h1>COMING SOON!</h1>

            <div dangerouslySetInnerHTML={{ __html: topContent }}></div>

            <div
              className="button"
              data-aos="fade-up"
              onClick={() => {
                window.open("https://discord.gg/pKGjBGN5", "_blank").focus();
              }}
            >
              <div className="top-part">
                <p>Join Discord</p>
                <svg
                  width="322"
                  height="92"
                  viewBox="0 0 322 92"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M287.266 0H27.5359H0L27.5359 34.9752V92H321.5V34.9752L287.266 0Z"
                    fill="#48A9E0"
                  />
                </svg>
              </div>

              <svg
                width="323"
                height="92"
                viewBox="0 0 323 92"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="outline"
              >
                <path
                  d="M287.926 1H29.4074H2L29.4074 35.2149V91H322V35.2149L287.926 1Z"
                  stroke="white"
                />
              </svg>
            </div>
          </div>
        </section>

        <section className="bottom-content">
          <div className="container">
            <div dangerouslySetInnerHTML={{ __html: bottomContent }}></div>
          </div>
        </section>

        <footer>
          <img
            src="/assets/images/pages/landing/footer-img-1.png"
            alt=""
            className="footer-img-1"
          />
          <img
            src="/assets/images/pages/landing/footer-img-2.png"
            alt=""
            className="footer-img-2"
          />

          <div className="container">
            <div className="social-links">
              <a href="https://twitter.com/altlanteansoc" target="_BLANK">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5 0C7.83594 0 0 7.83594 0 17.5C0 27.1641 7.83594 35 17.5 35C27.1641 35 35 27.1641 35 17.5C35 7.83594 27.1641 0 17.5 0ZM25.9102 13.1914C25.9219 13.375 25.9219 13.5664 25.9219 13.7539C25.9219 19.4883 21.5547 26.0938 13.5742 26.0938C11.1133 26.0938 8.83203 25.3789 6.91016 24.1484C7.26172 24.1875 7.59766 24.2031 7.95703 24.2031C9.98828 24.2031 11.8555 23.5156 13.3438 22.3516C11.4375 22.3125 9.83594 21.0625 9.28906 19.3438C9.95703 19.4414 10.5586 19.4414 11.2461 19.2656C10.2646 19.0662 9.38232 18.5331 8.74928 17.757C8.11624 16.9808 7.77143 16.0094 7.77344 15.0078V14.9531C8.34766 15.2773 9.02344 15.4766 9.73047 15.5039C9.1361 15.1078 8.64866 14.5711 8.31137 13.9415C7.97408 13.3119 7.79736 12.6088 7.79688 11.8945C7.79688 11.0859 8.00781 10.3477 8.38672 9.70703C9.47618 11.0482 10.8357 12.1451 12.3768 12.9264C13.918 13.7078 15.6063 14.1561 17.332 14.2422C16.7188 11.293 18.9219 8.90625 21.5703 8.90625C22.8203 8.90625 23.9453 9.42969 24.7383 10.2734C25.7187 10.0898 26.6562 9.72266 27.4922 9.23047C27.168 10.2344 26.4883 11.082 25.5859 11.6172C26.4609 11.5234 27.3047 11.2813 28.0859 10.9414C27.4961 11.8086 26.7578 12.5781 25.9102 13.1914V13.1914Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a
                href="https://instagram.com/ALTlanteansofficialclub"
                target="_BLANK"
              >
                <svg
                  width="36"
                  height="35"
                  viewBox="0 0 36 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6211 35C27.2861 35 35.1211 27.165 35.1211 17.5C35.1211 7.83502 27.2861 0 17.6211 0C7.95611 0 0.121094 7.83502 0.121094 17.5C0.121094 27.165 7.95611 35 17.6211 35ZM12.7174 5.64999C13.9862 5.59457 14.3923 5.57999 17.6217 5.57999H17.6187C20.8525 5.57999 21.2556 5.59457 22.526 5.64999C23.7918 5.70686 24.6576 5.90374 25.4162 6.19249C26.2105 6.4851 26.9299 6.94452 27.524 7.53853C28.1293 8.12139 28.5978 8.82657 28.8969 9.60499C29.19 10.3458 29.3908 11.1946 29.4503 12.4356C29.5068 13.681 29.5217 14.0777 29.5217 17.2467C29.5217 20.4156 29.5068 20.8123 29.4503 22.0562C29.3908 23.2987 29.19 24.146 28.8969 24.8883C28.592 25.6554 28.1859 26.3058 27.524 26.9548C26.9302 27.5484 26.2113 28.0078 25.4177 28.3008C24.6605 28.5896 23.7933 28.785 22.5275 28.8433C21.2571 28.8987 20.854 28.9133 17.6217 28.9133C14.3893 28.9133 13.9847 28.8987 12.7144 28.8433C11.4471 28.7864 10.5843 28.5896 9.82569 28.3008C9.04327 28.0033 8.37984 27.6037 7.71939 26.9548C7.05746 26.3058 6.65137 25.6554 6.34643 24.8883C6.0519 24.146 5.85258 23.2987 5.79308 22.0562C5.73655 20.8123 5.72168 20.4156 5.72168 17.2481C5.72168 14.0777 5.73655 13.681 5.79308 12.4342C5.85109 11.1946 6.0519 10.3458 6.34643 9.60499C6.64558 8.82659 7.11409 8.12142 7.71939 7.53853C8.31364 6.94474 9.03299 6.48535 9.82718 6.19249C10.5843 5.90374 11.4486 5.70832 12.7174 5.64999ZM17.6232 7.68291H16.5551V7.67999C14.3373 7.68145 13.9119 7.69603 12.8141 7.74561C11.6538 7.79811 11.0246 7.9877 10.6051 8.14811C10.0488 8.35957 9.65314 8.61186 9.23664 9.0202C8.82014 9.42853 8.56132 9.81791 8.34563 10.3619C8.182 10.7731 7.98863 11.3914 7.93508 12.5289C7.87855 13.7583 7.86665 14.1258 7.86665 17.2408C7.86665 20.3573 7.87855 20.7262 7.93508 21.9556C7.98714 23.0931 8.182 23.7114 8.34414 24.1212C8.53562 24.6282 8.8406 25.0867 9.23664 25.4629C9.6206 25.8502 10.0882 26.1482 10.6051 26.335C11.0246 26.4954 11.6538 26.685 12.8141 26.7375C14.068 26.7929 14.4459 26.806 17.6232 26.806C20.8005 26.806 21.1768 26.7929 22.4308 26.7375C23.5925 26.685 24.2232 26.4954 24.6397 26.335C25.196 26.1235 25.5917 25.8712 26.0082 25.4629C26.4039 25.0873 26.7084 24.6293 26.8992 24.1227C27.0614 23.7114 27.2562 23.0946 27.3083 21.9571C27.3663 20.7277 27.3782 20.3573 27.3782 17.2437C27.3782 14.1302 27.3663 13.7612 27.3083 12.5319C27.2562 11.3944 27.0628 10.776 26.8992 10.3662C26.6835 9.82082 26.4262 9.43291 26.0097 9.02457C25.5932 8.61624 25.196 8.36249 24.6412 8.15103C24.2217 7.99207 23.591 7.80103 22.4308 7.74999C21.1768 7.69311 20.8005 7.68291 17.6232 7.68291ZM23.4283 9.72614C23.6016 9.65578 23.7873 9.61957 23.9748 9.61957C24.3535 9.61957 24.7167 9.76707 24.9845 10.0296C25.2523 10.2922 25.4028 10.6483 25.4028 11.0196C25.4028 11.3909 25.2523 11.747 24.9845 12.0095C24.7167 12.2721 24.3535 12.4196 23.9748 12.4196C23.7873 12.4196 23.6016 12.3834 23.4283 12.313C23.2551 12.2426 23.0976 12.1395 22.965 12.0095C22.8324 11.8795 22.7273 11.7252 22.6555 11.5553C22.5837 11.3855 22.5468 11.2034 22.5468 11.0196C22.5468 10.8357 22.5837 10.6537 22.6555 10.4838C22.7273 10.314 22.8324 10.1596 22.965 10.0296C23.0976 9.89962 23.2551 9.7965 23.4283 9.72614ZM15.255 11.6848C16.0076 11.3892 16.8126 11.2434 17.6232 11.2558C19.2275 11.2804 20.7576 11.9224 21.8833 13.0434C23.009 14.1643 23.64 15.6743 23.64 17.2474C23.64 18.8204 23.009 20.3304 21.8833 21.4514C20.7576 22.5724 19.2275 23.2144 17.6232 23.2389C16.8126 23.2513 16.0076 23.1055 15.255 22.81C14.5025 22.5145 13.8174 22.0751 13.2397 21.5175C12.662 20.9599 12.2033 20.2952 11.8901 19.5621C11.577 18.829 11.4157 18.0422 11.4157 17.2474C11.4157 16.4526 11.577 15.6658 11.8901 14.9327C12.2033 14.1996 12.662 13.5349 13.2397 12.9773C13.8174 12.4197 14.5025 11.9803 15.255 11.6848ZM20.4284 14.4965C19.6844 13.7671 18.6753 13.3573 17.6232 13.3573C16.571 13.3573 15.5619 13.7671 14.818 14.4965C14.074 15.2259 13.656 16.2151 13.656 17.2467C13.656 18.2782 14.074 19.2675 14.818 19.9969C15.5619 20.7263 16.571 21.136 17.6232 21.136C18.6753 21.136 19.6844 20.7263 20.4284 19.9969C21.1724 19.2675 21.5903 18.2782 21.5903 17.2467C21.5903 16.2151 21.1724 15.2259 20.4284 14.4965Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a href="https://discord.gg/pKGjBGN5" target="_BLANK">
                <svg
                  width="31"
                  height="35"
                  viewBox="0 0 31 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.3175 16.625C20.3175 17.6925 19.53 18.5675 18.5325 18.5675C17.5525 18.5675 16.7475 17.6925 16.7475 16.625C16.7475 15.5575 17.535 14.6825 18.5325 14.6825C19.53 14.6825 20.3175 15.5575 20.3175 16.625ZM12.145 14.6825C11.1475 14.6825 10.36 15.5575 10.36 16.625C10.36 17.6925 11.165 18.5675 12.145 18.5675C13.1425 18.5675 13.93 17.6925 13.93 16.625C13.9475 15.5575 13.1425 14.6825 12.145 14.6825ZM30.625 3.605V35C26.2162 31.1039 27.6262 32.3936 22.505 27.6325L23.4325 30.87H3.5875C1.61 30.87 0 29.26 0 27.265V3.605C0 1.61 1.61 0 3.5875 0H27.0375C29.015 0 30.625 1.61 30.625 3.605ZM25.6375 20.195C25.6375 14.56 23.1175 9.9925 23.1175 9.9925C20.5975 8.1025 18.2 8.155 18.2 8.155L17.955 8.435C20.93 9.345 22.3125 10.6575 22.3125 10.6575C18.1555 8.37915 13.2724 8.37874 9.24 10.15C8.5925 10.4475 8.2075 10.6575 8.2075 10.6575C8.2075 10.6575 9.66 9.275 12.81 8.365L12.635 8.155C12.635 8.155 10.2375 8.1025 7.7175 9.9925C7.7175 9.9925 5.1975 14.56 5.1975 20.195C5.1975 20.195 6.6675 22.7325 10.535 22.855C10.535 22.855 11.1825 22.0675 11.7075 21.4025C9.485 20.7375 8.645 19.3375 8.645 19.3375C8.90244 19.5177 9.32695 19.7513 9.3625 19.775C12.3163 21.4292 16.5121 21.9711 20.2825 20.3875C20.895 20.16 21.5775 19.8275 22.295 19.355C22.295 19.355 21.42 20.79 19.1275 21.4375C19.6525 22.1025 20.2825 22.855 20.2825 22.855C24.15 22.7325 25.6375 20.195 25.6375 20.195V20.195Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>

            <p>
              &copy; 2022 - <span>Altlanteans</span> | All Rights Reserved
              <br />
              Brought to You by{" "}
              <a href="https://nftconstructer.com/" target="_BLANK">
                NFT Constructer
              </a>
            </p>
          </div>
        </footer>
      </main>
    </React.Fragment>
  );
};

export default Announcements;
